<form [formGroup]="form">
  <div class="row">
    <div class="col-md-6 form-group">
      <label>{{ 'software.name' | translate }}</label>
      <app-input-with-error [control]="this.form.controls['name']"></app-input-with-error>
    </div>
    <div class="col-md-6 form-group">
      <label>{{ 'software.status' | translate }}</label>
      <app-input-with-error [control]="this.form.controls['status']" [inputType]="'select'" [selectValues]="softwareStatusItems" [selectNames]="softwareStatusNames" [translateSelect]="false"></app-input-with-error>
    </div>
    <div class="col-md-6 form-group">
      <label>{{ 'software.visibility' | translate }}</label>
      <app-input-with-error [control]="this.form.controls['visibility']" [inputType]="'select'" [selectValues]="softwareVisibilityItems" [selectNames]="softwareVisibilityNames" [translateSelect]="false"></app-input-with-error>
    </div>
    <div class="col-md-6 form-group">
      <label>{{ 'software.type' | translate }}</label>
      <app-input-with-error [control]="this.form.controls['type']" [inputType]="'select'" [selectValues]="softwareTypeIds" [selectNames]="softwareTypeNames" [translateSelect]="false"></app-input-with-error>
    </div>
    <div class="col-md-6 form-group">
      <label>{{ 'software.platform' | translate }}</label>
      <app-input-with-error [control]="this.form.controls['platform']" [inputType]="'select'" [selectValues]="softwarePlatformIds" [selectNames]="softwarePlatformNames" [translateSelect]="false"></app-input-with-error>
    </div>
    <div class="col-md-6 form-group">
      <label>{{ 'software.iconUrl' | translate }}</label>
      <app-input-with-error [control]="this.form.controls['iconUrl']"></app-input-with-error>
    </div>
    <div class="col-md-12 form-group">
      <label>{{ 'software.description' | translate }}</label>
      <app-input-with-error [control]="this.form.controls['description']" inputType="textarea"></app-input-with-error>
    </div>
    <app-error [error]="error"></app-error>
  </div>
</form>
